import {Tooltip} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {convertStringToCamelCase} from 'shared/web';

interface MarketSituationAndPriceDynamicsTooltipProps {
  sourcingVehicle?: SourcingVehicleResponseBody | null;
  children: React.ReactNode;
}

export function MarketSituationAndPriceDynamicsTooltip(
  props: MarketSituationAndPriceDynamicsTooltipProps
) {
  const marketSituation = getTranslationKey(props.sourcingVehicle?.marketSituationCategory);
  const priceDynamics = getTranslationKey(props.sourcingVehicle?.priceDynamicsCategory);

  return (
    <Tooltip
      label={
        isNotNil(props.sourcingVehicle?.marketSituationCategory) ||
        isNotNil(props.sourcingVehicle?.priceDynamicsCategory) ? (
          <VStack>
            <Show when={isNotNil(marketSituation)}>
              <Text color="white" size="xSmall">
                {i18n.t(`entity.marketSituationCategory.labels.${marketSituation}`)}
              </Text>
            </Show>
            <Show when={isNotNil(priceDynamics)}>
              <Text color="white" size="xSmall">
                {i18n.t(`entity.priceDynamicsCategory.labels.${priceDynamics}`)}
              </Text>
            </Show>
          </VStack>
        ) : null
      }
    >
      {props.children}
    </Tooltip>
  );
}

// Transforms "MARKET_SITUATION_MAJOR_SHORTAGE" to "majorShortage"
const getTranslationKey = (key: string | null | undefined) =>
  isNotNil(key) ? convertStringToCamelCase(key.replace(/^.*?_(.*?_)/, '')) : null;
